import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext } from 'react';
import { BasicInfoInputExtended } from './detailsPage/detailsPageUtilities/personBasicInformation';

type PersonContexProps = {
    children: ReactNode;
    personData?: BasicInfoInputExtended;
    setPersonData?: Dispatch<SetStateAction<BasicInfoInputExtended>>;
    isBusinessContactEditorOpen?: boolean;
    setIsBusinessContactEditorOpen?: Dispatch<SetStateAction<boolean>>;
};

export const PersonContext = createContext<PersonContexProps>(null);

export const PersonProvider = ({
    personData,
    setPersonData,
    children,
    isBusinessContactEditorOpen,
    setIsBusinessContactEditorOpen
}: PersonContexProps) => {
    return (
        <PersonContext.Provider
            value={{
                personData,
                setPersonData,
                children,
                isBusinessContactEditorOpen,
                setIsBusinessContactEditorOpen
            }}
        >
            {children}
        </PersonContext.Provider>
    );
};

export const usePersonProvider = () => {
    const context = useContext(PersonContext);
    if (!context) throw new Error('usePersonProvider must be used within a PersonContext');
    return context;
};
